"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildConfigRefined = void 0;
/**
 * Build config data
 * @param configProperties
 * @returns {*} {Config}
 */
const buildConfigRefined = (configProperties) => ({
    ID: configProperties.ID,
    orgInfo: configProperties.orgInfo,
    arts: configProperties.arts,
    dev: configProperties.dev,
    createAdvanceAccounts: configProperties.createAdvanceAccounts,
    createSSOAccounts: configProperties.createSSOAccounts,
    articulations: configProperties.articulations,
    precedents: configProperties.precedents,
    sla: configProperties.sla,
    cron: configProperties.cron,
});
exports.buildConfigRefined = buildConfigRefined;
//# sourceMappingURL=ConfigRefined.js.map